import { Component, Input, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserModel } from '@core/services/api.service';
import { LoadUsersAction } from '@ngxs-store/users-store/users.actions';
import { UsersState } from '@ngxs-store/users-store/users.state';
import { WorkSplitAction } from '@ngxs-store/work-split-store/work-split.actions';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-work-split-dialog',
  templateUrl: './work-split-dialog.component.html',
  styleUrls: ['./work-split-dialog.component.scss']
})
export class WorkSplitDialogComponent  {
    @Input() users: UserModel[];
    @Select(UsersState.getUsers) users$: Observable<UserModel[]>;
    categories: { value: number, label: string }[] = [
        { value: 17, label: 'On site Collection' },
        { value: 18, label: 'On site Delivery' },
        { value: 19, label: 'Intransit (all)' },
        { value: 20, label: 'Intransit update due soon' },
        { value: 21, label: 'Intransit overdue' },
        { value: 22, label: 'Update due' },
        { value: 23, label: 'Update due soon' },
        { value: 24, label: 'Update requested' },
        { value: 25, label: 'Collection late' },
        { value: 26, label: 'Awaiting POD' },
        { value: 27, label: 'On way to Collect' },
    ];
    activeAgents = [];
    selectedCat: number;
    selectedAgents: string[] = [];

    constructor(
        private dialogRef: MatDialogRef<WorkSplitDialogComponent>,
        private store: Store,
        @Inject(MAT_DIALOG_DATA) data: any
      ) {
        this.store.dispatch(new LoadUsersAction());
        this.users$.subscribe(users => {
          this.users = users;
          this.getActiveAgentsNames();
        });
      }


getActiveAgentsNames() {
    const activeUsers = this.users.filter(user => user.isActive && user.signalRConnected);
    this.activeAgents = activeUsers.map(manager => ({ id: manager.id, name: `${manager.firstname} ${manager.lastname}`, selected: false }));
}


  onCancelClick(): void {
    this.dialogRef.close();
  }

  onAgentSelection(event: any, agentId: string): void {
        const index = this.selectedAgents.indexOf(agentId);
        if (event.checked && index === -1) {
            this.selectedAgents.push(agentId);
        } else if (!event.checked && index !== -1) {
            this.selectedAgents.splice(index, 1);
        }
    }


    onSaveClick(): void {
        this.store.dispatch(new WorkSplitAction(this.selectedCat, this.selectedAgents));
        this.dialogRef.close();
    }
}
